module.exports = __webpack_public_path__ + "img/caret-down-fill.678f6741.svg";